export const BAIT_IDS = [
  "Ad-Container",
  "Ad-Content",
  "Ad-Top",
  "AdBanner",
  "AdBar",
];
export const BAIT_DIV_STYLES =
  "width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;";
